import { ColumnDef } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import { FaEye, FaTrashAlt } from 'react-icons/fa';
import { Complaint } from '../../../types/complaint';
import {  ComplaintStatus } from '../../../types/enums';
//import sharedStyles from '../../SharedPageStyles.module.css';
import pageStyles from '../../Page.module.css';
import Icon from '../../../components/common/Icon';

type OpenDeleteDialogFn = (complaint: Complaint) => void;

// دالة مساعدة لعرض الحالات بألوان
const renderComplaintStatus = (status: ComplaintStatus) => {
  const styles: { [key in ComplaintStatus]: { color: string, text: string } } = {
    [ComplaintStatus.PENDING]: { color: 'orange', text: 'معلقة' },
    [ComplaintStatus.UNDER_REVIEW]: { color: 'blue', text: 'قيد المراجعة' },
    [ComplaintStatus.RESOLVED]: { color: 'green', text: 'تم حلها' },
    [ComplaintStatus.REJECTED]: { color: 'red', text: 'مرفوضة' },
  };
  const style = styles[status] || { color: 'black', text: status };
  return <span style={{ color: style.color, fontWeight: 'bold' }}>{style.text}</span>;
};

export const getComplaintColumns = (openDeleteDialog: OpenDeleteDialogFn): ColumnDef<Complaint>[] => [
  {
    header: 'رقم الشكوى',
    accessorKey: 'id',
  },
  {
    header: 'اسم المشتكي',
    accessorKey: 'complainant_name',
  },
  {
    header: 'المحامي المشتكى عليه',
    accessorFn: (row) => row.lawyer?.name || 'N/A',
  },
  {
    header: 'الحالة',
    accessorKey: 'status',
    cell: ({ row }) => renderComplaintStatus(row.original.status),
  },
  {
    header: 'تاريخ التقديم',
    accessorFn: (row) => new Date(row.created_at).toLocaleDateString('ar-EG'),
  },
  {
    id: 'actions',
    header: 'إجراءات',
    cell: ({ row }) => {
      const complaint = row.original;
      return (
        <div className={pageStyles.actionButtons}>
          <Link to={`/admin/complaints/view/${complaint.id}`} className={`${pageStyles.actionButton} ${pageStyles.view}`} title="عرض التفاصيل">
             <Icon as={FaEye} style={pageStyles.icon } />
          </Link>
          <button onClick={() => openDeleteDialog(complaint)} className={`${pageStyles.actionButton} ${pageStyles.delete}`} title="حذف">
            <Icon as={FaTrashAlt} style={pageStyles.icon } />
          </button>
        </div>
      );
    },
  },
];
